import { NextPage } from 'next'

import AddressWithImage from '@/components/addressWithImage'
import ContactForm from '@/components/contactForm'
import ContactUsBanner from '@/components/contactUsBanner'
import Footer from '@/components/footer'
import Header from '@/components/navigation'
import { STRINGS } from '@/constants/contactUs'

const contactUsAssetDir = '/assets/images/contact-us'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const ContactUs: NextPage = () => {
  return (
    <>
      <main className="max-w-7xl m-auto font-natosans">
        <section className="px-4">
          <Header />
        </section>
        <section className="mt-4 h-full w-full">
          <h1 className="text-black text-[45px] leading-[1.1] py-[30px] font-natosans-medium px-4">
            {STRINGS.GET_IN_TOUCH}
          </h1>
          <ContactUsBanner />
        </section>
        <AddressWithImage
          addressTitle={STRINGS.HEAD_OFFICE}
          address={STRINGS.HEAD_OFFICE_ADDRESS}
          image={`${contactUsAssetDir}/bihar-employees`}
          imagePosition="left"
          icon={`${contactUsAssetDir}/head-office`}
          iconAlt={STRINGS.HEAD_OFFICE}
          alt="Employees from head office in Bihar"
          loading="eager"
          iconWidth={84}
          iconHeight={95}
        />
        <AddressWithImage
          addressTitle={STRINGS.CORPORATE_OFFICE}
          address={STRINGS.CORPORATE_OFFICE_ADDRESS}
          image={`${contactUsAssetDir}/gurugram-team`}
          imagePosition="right"
          icon={`${contactUsAssetDir}/corporate-office`}
          iconAlt={STRINGS.CORPORATE_OFFICE}
          alt="Employees from corporate office in Gurugram"
          iconHeight={100}
          iconWidth={100}
        />
        <section className="bg-[#081521] px-4 mt-11">
          <p className="text-white pt-20 mb-2.5 md:pl-[30px] text-5xl leading-[1.1]">
            {STRINGS.DROP_AN_ENQUIRY}
          </p>
          <ContactForm />
        </section>
      </main>
      <Footer />
    </>
  )
}

export default ContactUs
